<template>
  <div id="links_href" class="links-bg-color">
  <div class="max-w-7xl mx-auto py-20">
    <div class="flex justify-center items-center px-10">
      <div class="link-dots bg-center hidden sm:block"></div>
        <div class="w-72 flex flex-none justify-center">
          <img src="@/assets/title-link.svg" alt="其他連結"/>
        </div>
      <div class="link-dots bg-center hidden sm:block"></div>
    </div>
    <div class="mt-16 px-10">
      <Carousel :settings="settings" :breakpoints="breakpoints" indicator-type="disc">
        <!-- 其他連結Start -->
        <Slide v-for='slide in links' :key="slide">
          <div class="mx-5">
            <img v-if="slide.image_url.length !== 0" :src="slide.image_url" alt="連他連結縮圖" class="mx-auto border-8 border-white"/>
            <img v-else src="@/assets/book1.png" alt="連他連結預設縮圖" class="mx-auto border-8 border-white"/>
            <img src="@/assets/link-bg.png" alt="連他連結縮圖陰影" class="mx-auto"/>
            <div class="flex justify-center">
              <a :href="slide.link_url" target="_blank">
                <div class="link-btn text-white py-5 px-6 text-lg mt-5">
                  {{slide.title}}
                </div>
              </a>
            </div>
          </div>
        </Slide>
        <!-- 其他連結End -->
        <template #addons="{ slidesCount }">
          <div class="mt-10">
          <Pagination />
          </div>
          <Navigation v-if="slidesCount > 3"/>
        </template>
      </Carousel>
    </div>
  </div>
  <div class="link-bg-bottom w-full bg-center"></div>
  </div>
</template>

<script>
import { getLinks } from '@/api/links'
import { Carousel, Navigation, Slide, Pagination } from 'vue3-carousel';

export default {
  name: "Links",
  components: {
    Carousel,
    Slide,
    Navigation,
    Pagination,
  },
  data() {
    return {
      links: [],
      // carousel settings
      settings: {
        itemsToShow: 1,
        snapAlign: 'center',
      },

      breakpoints: {
        700: {
          itemsToShow: 2,
          snapAlign: 'center',
        },
        1024: {
          itemsToShow: 3,
          snapAlign: 'center',
        },
      },
    };
  },
  mounted() {
    getLinks().then(
      (response) => {
        this.links = response.data;
      },
      (error) => {
        this.content =
          (error.response &&
            error.response.data &&
            error.response.data.message) ||
          error.message ||
          error.toString();
      }
    );
  },
};
</script>

<style>
.links-bg-color{
  background-color: #EBE3DB;
}

.link-dots{
  width: 100%;
  height: 35px;
  background-image: url("../../assets/link-dots.svg");
}

.link-btn{
  width: 230px;
  background-color: #64859D;
  mask-image: url(../../assets/btn-bg.svg);
}

.link-btn:hover {
  background-color: #405D73;
}

.link-bg-bottom{
    width: 100%;
    height: 80px;
    background-image: url("../../assets/link-bg-bottom.svg");
}

.carousel__pagination-button {
  border-radius: 50%;
  height: 1rem ;
  width: 1rem;
  margin: 6px;
}

.carousel__prev{
  left: -15px;
}

.carousel__next{
  right: -15px;
}

:root{
  --carousel-color-primary:#A8897C;
  --carousel-color-secondary:#b3b3b3;
}
</style>
